export const SubscriptionStatusCode = {
  PENDING_PAYMENT: 'PENDING_PAYMENT',
  NOT_STARTED: 'NOT_STARTED',
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED',
  CANCELLED: 'CANCELLED'
};

export const SubscriptionStatus = {
  [SubscriptionStatusCode.PENDING_PAYMENT]: 'Pending payment',
  [SubscriptionStatusCode.NOT_STARTED]: 'Not started',
  [SubscriptionStatusCode.ACTIVE]: 'Active',
  [SubscriptionStatusCode.EXPIRED]: 'Expired',
  [SubscriptionStatusCode.CANCELLED]: 'Cancelled'
};

export const SubscriptionCode = {
  TH_FP_6M: 'TH_FP_6M',
  TH_FP_12M: 'TH_FP_12M',
  TH_PP_6M: 'TH_PP_6M',
  TH_PP_12M: 'TH_PP_12M'
};

export const SubscriptionCodeTitle = {
  [SubscriptionCode.TH_FP_6M]: 'Thalys Frequent Pass 6 Month',
  [SubscriptionCode.TH_FP_12M]: 'Thalys Frequent Pass 12 Month',
  [SubscriptionCode.TH_PP_6M]: 'Thalys Premium Pass 6 Month',
  [SubscriptionCode.TH_PP_12M]: 'Thalys Premium Pass 12 Month'
};
